<template>


    <b-modal ref="memberFeedbackModal" header-bg-variant="primary" header-text-variant="white" 
    size="lg" no-close-on-backdrop hide-header hide-footer no-close-on-esc  hide-header-close>

       
        <template #modal-header>
            <div class="mx-auto text-center text-white">
                Student Feedback
            </div>           
        </template>
       

        <div id="ratingsForm" v-show="showRatings">

           
            <div class="info-container">
                <h5 class="text-maroon">Student Feedback</h5>
                <h6 class="font-weight-bold">Your student feedbacks and suggestions will assist us in continuosly improving our services</h6>
                <hr/>
            </div>
         

            <b-alert show variant="danger" v-show="errorMessage">
                <div class="d-flex">
                    <div class="flex">
                         <b-icon icon="exclamation-circle-fill" variant="danger" font-scale="2"></b-icon> 
                    </div>
                    <div class="flex pl-2 pt-1 w-100  error-message">
                        {{ errorMessage }}
                    </div>  
                </div>
            </b-alert> 

             <div id="lessonMaterialInfoContainer" class="row">
                <div id="lessonMaterialInfo" class="col-12">
                    <div class="row">

                        <div class="col-5"> 
                            <div class="title">           
                                Lesson Details
                            </div>
                            <hr class="m-0">
                            <div class="text-secondary small pt-1"> 
                                The detailed information of the lesson 
                            </div>
                        </div>

                        <div class="col-7">
                            <div class="card block">
                                <div class="card-body">
                                    <div class="form-group row mb-2">
                                        <label class="col-sm-4 col-form-label col-form-label-sm font-weight-bold text-dark mb-0">Course</label>
                                        <div class="col-sm-8">
                                            <input
                                                v-model="material.course"
                                                type="text"
                                                class="form-control form-control-sm"
                                                required
                                            >
                                        </div>
                                    </div>
                                    <div class="form-group row mb-2">
                                        <label class="col-sm-4 col-form-label col-form-label-sm font-weight-bold text-dark mb-0">Material</label>
                                        <div class="col-sm-8">
                                            <input
                                                v-model="material.material"
                                                type="text"
                                                class="form-control form-control-sm"
                                                required
                                            >
                                        </div>
                                    </div>
                                    <div class="form-group row mb-0">
                                        <label class="col-sm-4 col-form-label col-form-label-sm font-weight-bold text-dark mb-0">Subject</label>
                                        <div class="col-sm-8">
                                            <input
                                                v-model="material.subject"
                                                type="text"
                                                class="form-control form-control-sm"
                                                required
                                            >
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
             </div>

            <div id="ratingsContainer" class="row">
                <div id="starsRating" class="col-12  mt-3">
                    <div class="row">
                        <div class="col-5"> 
                            <div class="title">           
                                Student Performance
                            </div>
                            <hr class="m-0">
                            <div class="text-secondary small pt-1">
                                <div class="font-weight-bold">Rate understanding from 1 to 5 stars</div>
                                1 star = 0–19% &nbsp;|&nbsp; 2 stars = 20–40%<br>
                                3 stars = 41–64% &nbsp;|&nbsp; 4 stars = 65–85%<br>
                                5 stars = 86–100%
                            </div>
                        </div>
                        <div class="col-7"> 
                            <div class="mt-3">
                                <star-rating v-model="studentPerformanceRating" 
                                v-bind:show-rating="false" v-bind:star-size="30" 
                                v-bind:animate="true" v-bind:padding="5"></star-rating>
                                <div v-if="performanceGradeLabel" class="text-primary small mt-2 font-weight-bold">
                                    {{ performanceGradeLabel }}
                                </div>
                            </div>
                        </div>                
                    </div>
                </div>
            </div>

            <!-- Lesson status (complete/incomplete) hidden — lesson is marked completed on submit -->
            <!--
            <div id="lessonStatusContainer" class="row">...</div>
            -->

            <div id="feedbackContainer" class="row" v-show="showFeedback">
                <div id="feedbackForm" class="col-12">
                    <div class="row mt-3">
                        <div class="col-5">                            
                            <div class="title">Student Feeback</div>          
                            <hr class="m-0">
                            <div class="text-secondary small pt-1">     
                                Student feedback will help us understand our student's demand and 
                                make the course better and improve our services
                            </div>                            
                        </div>
                        <div class="col-7">                        
                            <vue-ckeditor v-model="feedback" :config="config" @blur="onEditorBlur($event)" @focus="onEditorFocus($event)" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="feedback-optional-actions row mt-3">
                <div class="col-12 d-flex flex-wrap justify-content-center">
                    <b-button
                        type="button"
                        variant="info"
                        size="sm"
                        class="mx-1 mb-2"
                        @click="toggleTeacherNotesForm"
                    >
                        {{ showTeacherNotesForm ? "Hide Teacher's note" : "Add Teacher's note" }}
                    </b-button>
                    <b-button
                        type="button"
                        variant="info"
                        size="sm"
                        class="mx-1 mb-2"
                        @click="toggleHomeworkForm"
                    >
                        {{ showHomeworkForm ? 'Hide Homework' : 'Add Homework' }}
                    </b-button>
                </div>
            </div>

            <div v-if="showTeacherNotesForm" id="notesContainer" class="row mt-2">
                <div id="notesForm" class="col-12">
                    <div class="row">
                        <div class="col-5">
                            <div class="title">Teacher Notes</div>
                            <hr class="m-0">
                            <div class="text-secondary small pt-1">
                                Add a note for the next teacher (optional)
                            </div>
                        </div>
                        <div class="col-7">
                            <vue-ckeditor v-model="notes" :config="config" @blur="onEditorBlur($event)" @focus="onEditorFocus($event)" />
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="showHomeworkForm" id="homeWorkContainer" class="row mt-2">
                <div id="homeWorkForm" class="col-12">
                    <div class="row">
                        <div class="col-5">
                            <div class="title">Student Homework</div>
                            <hr class="m-0">
                            <div class="text-secondary small pt-1">
                                Attach homework for your student (optional)
                            </div>
                        </div>
                        <div class="col-7">
                            <HomeWorkUploader
                                ref="homeWorkUploader"
                                :user_info="user_info"
                                :reservation="activeReservation"
                                :api_token="api_token"
                                :csrf_token="csrf_token"
                                @post-feedback="postFeedback"
                            />
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="mt-4 mb-2 text-center">
                <button class="btn btn-success" @click="submitFeedback()">

                    <b-icon icon="exclamation-circle-fill" variant="danger" v-show="errorMessage">
                    </b-icon> 

                    Submit Feedback
                </button>
            </div>            
        </div>

    </b-modal>

</template>

<style scoped>

    .error-message { 
        vertical-align: text-bottom;
    }

    .title {
        min-height: 40px;
        display: flex;
        align-items: center;
        font-weight: bold;
    }

    .feedback-optional-actions .btn {
        min-width: 170px;
    }

</style>
<script>
import StarRating from 'vue-star-rating'
import VueCkeditor from 'vue-ckeditor2';
import HomeWorkUploader from './HomeWorkUploaderComponent.vue'

export default {
    name: "MemberFeebackComponent",
    components: { StarRating, VueCkeditor, HomeWorkUploader},
    props: {
        user_info: {
            type: [Object, String],
            required: true
        },
        reservation: Object,       
        csrf_token: String,		
        api_token: String 
    },        
    data() {
        return {
            consecutiveSchedules: [],

            errorMessage: null,

            //Selected LESSON
            files: [],

            lessonStatusSelected: null,
            options: [
                { value: null, text: 'SELECT AN OPTION' },
                { value: 'COMPLETED', text: 'COMPLETED' },
                { value: 'INCOMPLETE', text: 'INCOMPLETE' }                
            ],


            lessonSelected: null,
            nextLessonOptions: [
                { value: null, text: 'SELECT AN OPTION' },
            ],


            //forms
            showRatings: false,
            showFeedback: true,
            showMessage: false,

            //Stars Container Ratings
            //generalCourseRating: null,
            studentPerformanceRating: null,
            //teacherSelfPerformanceRating: null,

            //Contents
            feedback: null,
            message: null,     

            //Configuration for CKEditor
            config: {
                toolbar: [
                    [ 'Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', 'NumberedList' ],
                    
                ],
                removePlugins: ['easyimage', 'cloudservices', 'exportpdf'],
                height: 150
            },

            //reservationData
            reservationData: null,
            notes: "",
            homework: null,

            material: {
                course: '',
                material: '',
                subject: '',
                segments: [],
            },

            showTeacherNotesForm: false,
            showHomeworkForm: false,
        }
    },
    computed: {
        activeReservation() {
            return this.reservationData || this.reservation || {};
        },
        performanceGradeLabel() {
            const labels = {
                1: '0–19% understanding',
                2: '20–40% understanding',
                3: '41–64% understanding',
                4: '65–85% understanding',
                5: '86–100% understanding',
            };
            return labels[this.studentPerformanceRating] || '';
        },
    },
    methods: {
        toggleTeacherNotesForm() {
            this.showTeacherNotesForm = !this.showTeacherNotesForm;
        },
        toggleHomeworkForm() {
            this.showHomeworkForm = !this.showHomeworkForm;
        },
        updateConsecutiveSchedules(schedules) {
            this.consecutiveSchedules = schedules;
            console.log("consecutive schedules", this.consecutiveSchedules)
        },
        updateLessonDetails(newSegments) {
            if (!Array.isArray(newSegments) || newSegments.length === 0) {
                return;
            }
            let segments = newSegments;
            let course = segments[0];
            let subject = segments[segments.length - 1];
            let lessonMaterial = segments[segments.length - 2];

            this.material = {
                segments: segments,
                course: course,
                material: lessonMaterial,
                subject: subject,
            };
        },
        ensureMaterialInitialized() {
            if (!this.material || typeof this.material !== 'object') {
                this.material = {
                    course: '',
                    material: '',
                    subject: '',
                    segments: [],
                };
            }
        },
        setLessonMaterial(material) {
            if (!material) {
                return;
            }
            this.ensureMaterialInitialized();
            this.material = Object.assign({}, this.material, material);
        },
        async loadLessonReportCard(reservationData) {
            const scheduleId = reservationData && reservationData.schedule_id;
            if (!scheduleId) {
                return false;
            }

            try {
                const response = await axios.post(
                    '/api/getLessonReportCard?api_token=' + this.api_token,
                    { schedule_id: scheduleId }
                );

                if (response.data.success && response.data.material) {
                    const row = response.data.material;
                    if (row.course || row.material || row.subject) {
                        this.setLessonMaterial({
                            course: row.course || '',
                            material: row.material || '',
                            subject: row.subject || '',
                        });
                        return true;
                    }
                }
            } catch (error) {
                console.warn('loadLessonReportCard failed', error);
            }

            return false;
        },
        getLessonSlideDetails() {
            alert ("get lesson slide detials")
        
        },
        hideMemberFeedbackModal() {
            this.$refs['memberFeedbackModal'].hide();
        },
        async showMemberFeedbackModal(reservationData, files)
        {
            this.nextLessonOptions = [
                { value: null, text: 'SELECT AN OPTION' },
            ];

            if (files == null || files.length == 0) {
                this.nextLessonOptions.push({
                    value: 1,
                    text: 'LESSSON SLIDE ' + 1,
                });
            } else {
                Object.keys(files).forEach((item, index) => {
                    let lessonIndex = index + 1;
                    this.nextLessonOptions.push({
                        value: lessonIndex,
                        text: 'LESSSON SLIDE ' + lessonIndex,
                    });
                });
            }

            this.ensureMaterialInitialized();
            this.reservationData = reservationData;
            this.lessonStatusSelected = 'COMPLETED';
            this.showTeacherNotesForm = false;
            this.showHomeworkForm = false;
            await this.loadLessonReportCard(reservationData);
            this.showRatingsForm();
            this.$refs['memberFeedbackModal'].show();
        },
        showRatingsForm() {
            this.showRatings = true,
            this.showFeedback = true;
            this.showMessage = false;         
        },
        showFeebackForm() {
            this.showRatings = false,
            this.showFeedback = true;
            this.showMessage = false;
        },
        showMessageForm() {
            this.showRatings = false,
            this.showFeedback = false;
            this.showMessage = true;        
        },
        onEditorBlur (editor) {
            console.log(editor)
        },
        onEditorFocus (editor) {
            console.log(editor)
        },           
        isArrayValid(arr) {
            return arr.every(element => element === true || element >= 1 || element != null);
        },
        checkLessonRated() 
        {        
            return this.isArrayValid([this.studentPerformanceRating]);
        },
        hasLessonStatus() {
            return true;
        },
        feedbackPlainText() {
            if (!this.feedback) {
                return '';
            }
            return String(this.feedback)
                .replace(/<[^>]+>/g, ' ')
                .replace(/&nbsp;/gi, ' ')
                .replace(/\s+/g, ' ')
                .trim();
        },
        hasFeedback() {
            return this.feedbackPlainText().length > 0;
        },
        getHomeworkFileCount() {
            const uploader = this.$refs.homeWorkUploader;
            if (!uploader || typeof uploader.getFileCount !== 'function') {
                return 0;
            }
            return uploader.getFileCount();
        },
        hasLessonMaterial() {
            this.ensureMaterialInitialized();
            const course = String(this.material.course || '').trim();
            const material = String(this.material.material || '').trim();
            const subject = String(this.material.subject || '').trim();
            return course.length > 0 && material.length > 0 && subject.length > 0;
        },
        submitFeedback() {
            try {
            let homeworkCount = this.getHomeworkFileCount();
            let isLessonRated = this.checkLessonRated();
            let hasFeedback = this.hasFeedback();
            let hasLessonMaterial = this.hasLessonMaterial();

            if (isLessonRated == true && hasFeedback == true && hasLessonMaterial == true) {
                this.errorMessage = null;
                if (homeworkCount >= 1) {
                    const uploader = this.$refs.homeWorkUploader;
                    if (uploader && typeof uploader.startUpload === 'function') {
                        uploader.startUpload();
                    } else {
                        this.postFeedback();
                    }
                } else {
                    this.postFeedback();
                }
            } else if (isLessonRated == false && hasFeedback == false) {
                this.errorMessage = "Please rate your student and add a student feedback";
            } else if (isLessonRated == false) {
                this.errorMessage = "Please rate your student using stars";
            } else if (hasLessonMaterial == false) {
                this.errorMessage = "Please enter lesson course, material, and subject";
            } else if (hasFeedback == false) {
                this.errorMessage = "Please add a student feedback";
            } else {
                 this.errorMessage = "Oops! You have not rated your student and added a feedback";
            }
            } catch (error) {
                console.error('submitFeedback error', error);
                this.errorMessage = 'Could not submit feedback. Please try again.';
            }
        },
        postFeedback() {
            const reservation = this.reservationData || this.reservation;
            if (!reservation || !reservation.schedule_id) {
                this.errorMessage = 'Lesson reservation data is missing. Please refresh and try again.';
                return;
            }

            axios.post("/api/postMemberFeedback?api_token=" + this.api_token,
            {
                'method'                    : "POST",               
                'reservation'               : reservation,
                'consecutiveSchedules'      : this.consecutiveSchedules,
                'material'                  : JSON.stringify(this.material),
                'feedback'                  : this.feedback,
                //'message'                   : this.message, ()
                'lessonStatus'              : 'COMPLETED',
                'nextLessonSelected'        : this.lessonSelected,
                'studentPerformanceRating'  : this.studentPerformanceRating, 
                'notes'                     : this.notes,                 
                //generalCourseRating             : this.generalCourseRating,                 
                //teacherSelfPerformanceRating    : this.teacherSelfPerformanceRating
            }).then(response => {

                if (response.data.success == true) {

                    this.$refs['memberFeedbackModal'].hide();

                    this.$nextTick(() => {

                        setTimeout(() => {                  
                            this.redirect('admin');
                        }, 1000);
                    });                    
                } else {
                    this.errorMessage = response.data.message || 'Could not save feedback.';
                }
            }).catch((error) => {
                console.error('postMemberFeedback error', error);
                const message = (error.response && error.response.data && error.response.data.message)
                    || error.message
                    || 'Could not save feedback.';
                this.errorMessage = message;
            });

        },
        redirect(url) {
            window.location.href = window.location.origin + "/" + url
        },        

    }    
}
</script>